module.exports = function isMobile() {
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|windows phone|opera mini/i.test(
    window.navigator.userAgent.toLowerCase(),
  ); // eslint-disable-line no-undef
};
